import { render, staticRenderFns } from "./breedDamsYieldBreedingValue.vue?vue&type=template&id=c5724fb8&scoped=true&"
import script from "./breedDamsYieldBreedingValue.vue?vue&type=script&lang=js&"
export * from "./breedDamsYieldBreedingValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5724fb8",
  null
  
)

export default component.exports